import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-tab', {
    staticClass: "w-75",
    attrs: {
      "title": "Outras informações",
      "active": _vm.isTheCurrentTab,
      "disabled": !_vm.isTheCurrentTab && !_vm.store.isUpdate
    },
    on: {
      "click": function click() {
        return _vm.store.currentTab = _vm.informacoesTabIndex;
      }
    }
  }, [_c('label', [_vm._v("Validade")]), _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "validadeData",
      "label-for": "validadeData",
      "label": "Data"
    }
  }, [_c('b-form-datepicker', {
    attrs: {
      "locale": "pt-br"
    },
    model: {
      value: _vm.form.validade,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "validade", $$v);
      },
      expression: "form.validade"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "validadeHora",
      "label-for": "validadeHora",
      "label": "Hora"
    }
  }, [_c('b-form-timepicker', {
    attrs: {
      "locale": "pt-br"
    },
    on: {
      "input": _vm.setValidadeHour
    },
    model: {
      value: _vm.form.validadeHour,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "validadeHour", $$v);
      },
      expression: "form.validadeHour"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Status",
      "label-for": "status"
    }
  }, [_c('VueSelect', {
    ref: "buscarStatus",
    attrs: {
      "filterable": false,
      "options": _vm.allStatus
    },
    on: {
      "input": _vm.setStatus
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o status ")])], 2)], 1)], 1)], 1), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Peso Bruto",
      "label-for": "pesoBruto"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "pesoBruto",
      "name": "pesoBruto"
    },
    on: {
      "input": function input($event) {
        _vm.pesoEditado = true;
      }
    },
    model: {
      value: _vm.form.pesoBruto,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pesoBruto", $$v);
      },
      expression: "form.pesoBruto"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Peso Líquido",
      "label-for": "pesoLiquido"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "pesoLiquido",
      "name": "pesoLiquido"
    },
    on: {
      "input": function input($event) {
        _vm.pesoEditado = true;
      }
    },
    model: {
      value: _vm.form.pesoLiquido,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "pesoLiquido", $$v);
      },
      expression: "form.pesoLiquido"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1)], 1), _c('b-row', [_c('b-col', {}, [_c('b-form-group', {
    attrs: {
      "label": "Informações Adicionais",
      "label-for": "informacoesAdicionais"
    }
  }, [_c(VTextarea, {
    attrs: {
      "full-width": "",
      "no-resize": "",
      "rows": "1",
      "auto-grow": ""
    },
    model: {
      value: _vm.form.observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacao", $$v);
      },
      expression: "form.observacao"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };